import React from 'react';
import PropTypes from 'prop-types';

import Card from '../../../../../../components/Card';
import CardsSkeleton from '../../../../../../components/Skeletons/CardsSkeleton';
import { useFetchStatus } from '../../../../../../utils/fetchStatusUtils';

const Cards = (props) => {
  const { transactionsData, loadingState } = props;

  const numberOfStatistics = 3;
  const { isFulfilled } = useFetchStatus(loadingState);

  if (!isFulfilled) {
    return <CardsSkeleton count={numberOfStatistics} />;
  }

  const { transactionsCount, depositsAmount, expensesAmount } =
    transactionsData;

  return (
    <div className="card-container">
      <Card title="Transactions Total" content={transactionsCount} />
      <Card title="Expenses" content={`$${expensesAmount}`} />
      <Card title="Deposits" content={`$${depositsAmount}`} />
    </div>
  );
};

export default Cards;

Cards.propTypes = {
  transactionsData: PropTypes.shape({
    transactionsCount: PropTypes.number.isRequired,
    depositsAmount: PropTypes.number.isRequired,
    expensesAmount: PropTypes.number.isRequired,
  }),
  loadingState: PropTypes.string.isRequired,
};

Cards.defaultProps = {
  transactionsData: null,
};
